import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIpBlocks = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 13"
    {...props}
  >
    <path d="M1.064 1.627a.564.564 0 1 0 0-1.127.564.564 0 0 0 0 1.127" />
    <path
      fillRule="evenodd"
      d="M1.064 1a.064.064 0 1 0 0 .127.064.064 0 0 0 0-.127M0 1.064a1.064 1.064 0 1 1 2.127 0 1.064 1.064 0 0 1-2.127 0m4.26-.001a.75.75 0 0 1 .75-.75h9.755a.75.75 0 0 1 0 1.5H5.01a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
    <path d="M1.064 6.7a.564.564 0 1 0 0-1.126.564.564 0 0 0 0 1.127Z" />
    <path
      fillRule="evenodd"
      d="M1.064 6.074a.064.064 0 1 0 0 .127.064.064 0 0 0 0-.127M0 6.137a1.064 1.064 0 1 1 2.127 0 1.064 1.064 0 0 1-2.127 0m4.26 0a.75.75 0 0 1 .75-.75h9.755a.75.75 0 0 1 0 1.5H5.01a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
    <path d="M1.064 11.774a.564.564 0 1 0 0-1.127.564.564 0 0 0 0 1.127" />
    <path
      fillRule="evenodd"
      d="M1.064 11.146a.064.064 0 1 0 0 .128.064.064 0 0 0 0-.127ZM0 11.21a1.064 1.064 0 1 1 2.127 0 1.064 1.064 0 0 1-2.127 0m4.26 0a.75.75 0 0 1 .75-.75h9.755a.75.75 0 0 1 0 1.5H5.01a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIpBlocks;
